import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=bff827fc&scoped=true&"
import script from "./Toolbar.vue?vue&type=script&lang=js&"
export * from "./Toolbar.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=bff827fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff827fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bff827fc')) {
      api.createRecord('bff827fc', component.options)
    } else {
      api.reload('bff827fc', component.options)
    }
    module.hot.accept("./Toolbar.vue?vue&type=template&id=bff827fc&scoped=true&", function () {
      api.rerender('bff827fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/Toolbar.vue"
export default component.exports